<template>
  <!-- PC：下拉菜单选择四套主题 -->
  <div v-if="mode === 'pc'" class="theme-switcher-pc">
    <el-dropdown trigger="click" @command="handleSelect">
      <span class="theme-trigger" title="切换主题色">
        <span class="theme-dot" :style="{ backgroundColor: currentTheme.color }"></span>
        <span class="theme-label">主题</span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in themes" :key="item.key" :command="item.key">
          <span class="theme-option">
            <span class="theme-dot" :style="{ backgroundColor: item.color }"></span>
            <span class="theme-name">{{ item.name }}</span>
            <i v-if="item.key === currentKey" class="el-icon-check theme-check"></i>
          </span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

  <!-- 移动端：导航栏画笔图标 + 底部弹层 -->
  <div v-else class="theme-switcher-mobile">
    <van-icon name="brush-o" class="theme-icon" @click="showSheet = true" />
    <van-popup v-model="showSheet" position="bottom" round>
      <div class="theme-sheet">
        <div class="theme-sheet-title">选择主题色</div>
        <div
          v-for="item in themes"
          :key="item.key"
          class="theme-sheet-item"
          @click="handleSelect(item.key)"
        >
          <span class="theme-dot" :style="{ backgroundColor: item.color }"></span>
          <span class="theme-name">{{ item.name }}</span>
          <van-icon v-if="item.key === currentKey" name="success" class="theme-check" />
        </div>
        <div class="theme-sheet-cancel" @click="showSheet = false">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { THEME_LIST, applyTheme, getStoredTheme } from '@/utils/theme'
import api from '@/services/api'

export default {
  name: 'ThemeSwitcher',
  props: {
    // pc：下拉菜单；mobile：导航栏图标 + 弹层
    mode: {
      type: String,
      default: 'pc'
    }
  },
  data() {
    return {
      themes: THEME_LIST,
      currentKey: 'cinnabar',
      showSheet: false
    }
  },
  computed: {
    currentTheme() {
      return this.themes.find(item => item.key === this.currentKey) || this.themes[0]
    }
  },
  mounted() {
    this.currentKey = getStoredTheme()
  },
  methods: {
    handleSelect(key) {
      this.currentKey = applyTheme(key)
      this.showSheet = false
      // 游客只存本机；登录用户额外存到账号，下次登录自动恢复
      if (this.$store.state.token) {
        api.user.updateTheme(this.currentKey).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.theme-switcher-pc {
  .theme-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 4px;
    color: var(--ink-soft);
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: var(--paper-deep);
    }
  }

  .theme-label {
    font-size: 14px;
  }

  .theme-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid rgba(var(--gold-rgb), 0.5);
    flex-shrink: 0;
  }
}

.theme-option {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 96px;
}

.theme-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(var(--gold-rgb), 0.5);
  flex-shrink: 0;
}

.theme-name {
  flex: 1;
  font-size: 14px;
}

.theme-check {
  color: var(--accent);
}

.theme-switcher-mobile {
  .theme-icon {
    font-size: 20px;
    color: var(--ink);
  }

  .theme-sheet {
    padding: 8px 0 12px;
    background: var(--paper-card);
  }

  .theme-sheet-title {
    padding: 16px;
    text-align: center;
    font-family: "Songti SC", "STSong", "SimSun", serif;
    font-size: 16px;
    color: var(--ink);
    border-bottom: 1px solid var(--line-soft);
  }

  .theme-sheet-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    font-size: 15px;
    color: var(--ink);
    border-bottom: 1px solid var(--line-soft);

    &:active {
      background: var(--paper-2);
    }
  }

  .theme-sheet-cancel {
    margin-top: 8px;
    padding: 16px;
    text-align: center;
    font-size: 15px;
    color: var(--ink-light);
  }
}
</style>
